import React, { ErrorInfo } from "react";
import { captureError } from "../telemetry";
import { ErrorBoundaryFallback } from "./ErrorBoundaryFallback";

type State = {
  hasError: boolean;
  error?: Error | null;
};

export class ErrorBoundary extends React.Component<React.PropsWithChildren<object>, State> {
  constructor(props: React.PropsWithChildren<object>) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    captureError(error, {
      source: "ErrorBoundary",
      componentStack: info.componentStack ?? "",
    });
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback onReload={this.handleReload} />;
    }

    return this.props.children as React.ReactElement;
  }
}
